import { segmentsSlice, updateCounter } from 'common/filter/reducers/segments'
import { accountNotificationsListener } from 'utils/services/notificationsService'

export const segmentsActions = {
  ...segmentsSlice.actions,
  updateCounter,
}

accountNotificationsListener.on('segment_updated', (data, dispatch) => {
  dispatch(
    segmentsActions.updateItem({
      id: data.model.segment_id,
      data: data.model,
      rewrite: true,
    }),
  )
})
accountNotificationsListener.on('segment_counter_updated', (data, dispatch) => {
  dispatch(segmentsActions.updateCounter(data))
})
accountNotificationsListener.on('segment_deleted', (data, dispatch) => {
  dispatch(segmentsActions.deleteItem({ id: data.model.segment_id }))
})
accountNotificationsListener.on('segment_created', (data, dispatch) => {
  dispatch(
    segmentsActions.appendItem({
      item: data.model,
    }),
  )
})
